// Module
var code = `<div class="modal fade" tabindex="-1" role="dialog" data-bind="showModal: show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-bind="click: clear">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"></h4>
      </div>
      <div class="modal-body">
        <p data-bind="label:message"></p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          data-dismiss="modal"
          data-bind="click: clear, label: 'Cancel'"
        ></button>
        <button
          type="button"
          class="btn btn-success"
          data-dismiss="modal"
          data-bind="click: continue, label: 'cc_P_ACKNOWLWDGE'"
        ></button>
      </div>
    </div>
  </div>
</div>
`;
// Exports
module.exports = code;